import type { FC } from 'react';
import type { LinksFunction } from '@remix-run/node';

import clsx from 'clsx';

import {
  DbooThinkYouAreSafe,
  links as dbooThinkYouAreSafeLinks,
} from '@/components/dboo/dboo-think-you-are-safe/dboo-think-you-are-safe';
import {
  DbooProtectionPoints,
  links as dbooProtectionPointsLinks,
} from '@/components/dboo/dboo-protection-points/dboo-protection-points';
import {
  DbooWhatAreDataBrokers,
  links as dbooWhatAreDataBrokersLinks,
} from '@/components/dboo/dboo-what-are-data-brokers/dboo-what-are-data-brokers';

import type { DbooExplainerSectionProps } from './dboo-explainer-section.types';

import styles from './dboo-explainer-section.css?url';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
  ...dbooThinkYouAreSafeLinks(),
  ...dbooProtectionPointsLinks(),
  ...dbooWhatAreDataBrokersLinks(),
];

export const DbooExplainerSection: FC<DbooExplainerSectionProps> = ({
  className,
}) => {
  const sectionClassName = clsx('dboo-explainer-section', className);

  return (
    <section className={sectionClassName}>
      <DbooThinkYouAreSafe />
      <DbooWhatAreDataBrokers />
      <DbooProtectionPoints theme="dark" />
    </section>
  );
};
